import { render, staticRenderFns } from "./UserActionStatusChip.vue?vue&type=template&id=6fb5653a&"
import script from "./UserActionStatusChip.vue?vue&type=script&lang=js&"
export * from "./UserActionStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports